import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-howto',
	templateUrl: './howto.component.html',
	styleUrls: ['./howto.component.scss']
})
export class HowtoComponent implements OnInit {
	@Input() componentTypeID: string;
	@Input() customGuideUI: boolean;
	modalHeight = window.innerHeight * 0.8;
	howtoURL;
	customUIFileName = 'custom_ui_guide';

	constructor(private sanitation: DomSanitizer) {}

	ngOnInit() {
		const componentFileName = this.customGuideUI ? this.customUIFileName : this.componentTypeID;
		const url = `${environment.dmAssetsDomain}/creator/howto/${componentFileName}.html`;
		this.howtoURL = this.sanitation.bypassSecurityTrustResourceUrl(url);
	}
}
